'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CodeMirror from 'codemirror';
import FindReplaceMode from 'react-codemirror/enum/FindReplaceMode';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import Column from 'react-codemirror/decorator/_internal/components/panel/InputColumn';
import Row from 'react-codemirror/decorator/_internal/components/panel/InputRow';
import Button from 'react-codemirror/decorator/_internal/components/panel/Button';
import TextInput from 'react-codemirror/decorator/_internal/components/panel/TextInput';
const CLASS_NAME = 'CodeMirror-hs-findreplace';
const MODIFIER_BUTTON_CLASS = 'modifier-button';
const ACTION_BUTTON_CLASS = 'action-button';
export default class FindReplace extends Component {
  constructor(props) {
    super(props);
    this.onFindInput = this.onFindInput.bind(this);
    this.onReplaceInput = this.onReplaceInput.bind(this);
    this.onJumpToLineInput = this.onJumpToLineInput.bind(this);
  }
  /*
   * Event handlers
   */


  onFindInput(evt) {
    if (evt.nativeEvent instanceof KeyboardEvent) {
      // KeyboardEvent
      if (evt.key === 'Enter') {
        CodeMirror.e_stop(evt);

        if (evt.shiftKey) {
          this.props.onFindPrevious();
        } else {
          this.props.onFindNext();
        }
      }
    } else {
      // InputEvent
      CodeMirror.e_stop(evt);
      const {
        value
      } = evt.target;
      this.props.onFindInput(value);
    }
  }

  onReplaceInput(evt) {
    CodeMirror.e_stop(evt);
    const {
      value
    } = evt.target;
    this.props.onReplaceInput(value);
  }

  onJumpToLineInput(evt) {
    if (evt.nativeEvent instanceof KeyboardEvent) {
      // KeyboardEvent
      if (evt.key === 'Enter') {
        CodeMirror.e_stop(evt);
        this.props.onJumpToLine();
      }
    } else {
      // InputEvent
      CodeMirror.e_stop(evt);
      const {
        value
      } = evt.target;
      this.props.onJumpToLineInput(value);
    }
  }
  /*
   * Render
   */


  renderButton(children, props = {}) {
    return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
      children: children
    }));
  }

  renderInput(props = {}) {
    return /*#__PURE__*/_jsx(TextInput, Object.assign({}, props));
  }

  renderJumpToLine() {
    switch (this.props.mode) {
      case FindReplaceMode.JUMP_TO_LINE:
        break;

      default:
        return null;
    }

    return [/*#__PURE__*/_jsx(Column, {
      grow: 1,
      children: /*#__PURE__*/_jsx(Row, {
        children: this.renderInput({
          className: 'find-input',
          placeholder: 'line:column',
          onInput: this.onJumpToLineInput,
          onKeyPress: this.onJumpToLineInput,
          value: this.props.jumpToLineText
        })
      })
    }, "inputs"), /*#__PURE__*/_jsx(Column, {
      children: /*#__PURE__*/_jsx(Row, {
        children: this.renderButton('Jump to line', {
          title: 'Jump to line',
          className: ACTION_BUTTON_CLASS,
          onClick: this.props.onJumpToLine,
          disabled: !this.props.jumpToLineText
        })
      })
    }, "actions")];
  }

  renderFindReplace() {
    switch (this.props.mode) {
      case FindReplaceMode.FIND:
      case FindReplaceMode.REPLACE:
        break;

      default:
        return null;
    }

    return [
    /*#__PURE__*/

    /*
     * Modifiers
     */
    _jsx(Column, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [this.renderButton( /*#__PURE__*/_jsx(UIIcon, {
          name: "replace"
        }), {
          title: 'Toggle replace mode',
          className: MODIFIER_BUTTON_CLASS,
          onClick: this.props.onToggleMode,
          active: this.props.mode === FindReplaceMode.REPLACE
        }), this.renderButton('Aa', {
          title: 'Case sensitive',
          codeButton: true,
          className: MODIFIER_BUTTON_CLASS,
          onClick: this.props.onToggleCaseSensitivity,
          active: this.props.isCaseSensitive
        }), this.renderButton('.*', {
          title: 'Regular expression',
          codeButton: true,
          className: MODIFIER_BUTTON_CLASS,
          onClick: this.props.onToggleRegex,
          active: this.props.isRegex
        })]
      })
    }, "modifiers"),
    /*#__PURE__*/

    /*
     * Inputs
     */
    _jsxs(Column, {
      grow: 1,
      children: [/*#__PURE__*/_jsx(Row, {
        children: this.renderInput({
          className: 'find-input',
          placeholder: 'Find',
          onInput: this.onFindInput,
          onKeyPress: this.onFindInput,
          value: this.props.queryText
        })
      }), this.props.mode === FindReplaceMode.REPLACE && /*#__PURE__*/_jsx(Row, {
        children: this.renderInput({
          placeholder: 'Replace',
          onInput: this.onReplaceInput,
          value: this.props.replaceText
        })
      })]
    }, "inputs"),
    /*#__PURE__*/

    /*
     * Action Buttons
     */
    _jsxs(Column, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [this.renderButton( /*#__PURE__*/_jsx(UIIcon, {
          name: "previous"
        }), {
          title: 'Find previous',
          className: ACTION_BUTTON_CLASS,
          onClick: this.props.onFindPrevious,
          disabled: !this.props.queryText
        }), this.renderButton( /*#__PURE__*/_jsx(UIIcon, {
          name: "next"
        }), {
          title: 'Find next',
          className: ACTION_BUTTON_CLASS,
          onClick: this.props.onFindNext,
          disabled: !this.props.queryText
        }), this.renderButton('Find all', {
          title: 'Find all',
          className: ACTION_BUTTON_CLASS,
          onClick: this.props.onFindAll,
          disabled: !this.props.queryText
        })]
      }), this.props.mode === FindReplaceMode.REPLACE && /*#__PURE__*/_jsxs(Row, {
        children: [this.renderButton('Replace', {
          onClick: this.props.onReplaceNext,
          className: ACTION_BUTTON_CLASS,
          disabled: !this.props.queryText
        }), this.renderButton('Replace all', {
          onClick: this.props.onReplaceAll,
          className: ACTION_BUTTON_CLASS,
          disabled: !this.props.queryText
        })]
      })]
    }, "actions")];
  }

  render() {
    return /*#__PURE__*/_jsx("div", {
      className: classNames(CLASS_NAME, this.props.mode, this.props.className),
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "stretch",
        justify: "start",
        direction: "row",
        wrap: "nowrap",
        children: [this.renderFindReplace(), this.renderJumpToLine()]
      })
    });
  }

}
FindReplace.propTypes = {
  className: PropTypes.string,
  mode: PropTypes.oneOf(Object.keys(FindReplaceMode)).isRequired,
  isRegex: PropTypes.bool.isRequired,
  isCaseSensitive: PropTypes.bool.isRequired,
  queryText: PropTypes.string.isRequired,
  replaceText: PropTypes.string.isRequired,
  onToggleMode: PropTypes.func.isRequired,
  onToggleCaseSensitivity: PropTypes.func.isRequired,
  onToggleRegex: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onFindInput: PropTypes.func.isRequired,
  onReplaceInput: PropTypes.func.isRequired,
  onFindNext: PropTypes.func.isRequired,
  onFindAll: PropTypes.func.isRequired,
  onFindPrevious: PropTypes.func.isRequired,
  onReplaceNext: PropTypes.func.isRequired,
  onReplaceAll: PropTypes.func.isRequired,
  onJumpToLineInput: PropTypes.func.isRequired,
  onJumpToLine: PropTypes.func.isRequired,
  jumpToLineText: PropTypes.string.isRequired
};